import React, { useState, useEffect } from 'react';

const SuccessStoryCard = ({ story }) => {
  let base =
    'transition-all duration-300 flex flex-col justify-between h-full rounded-2xl shadow-xl px-4 py-6 sm:px-6 sm:py-8 bg-[#22295B] scale-100 z-20 shadow-2xl text-white w-full mx-auto';
  return (
    <div className={base}>
      <div className="flex items-center gap-4 mb-4">
        <img
          src={story.image}
          alt={story.name}
          className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-contain border-2 border-[#70CBA2]"
        />
        <div>
          <h3 className="text-lg text-[#70CBA2] font-bold">{story.name}</h3>
          <p className="text-gray-200 text-sm">{story.role}</p>
        </div>
      </div>
      <div className="mb-4">
        <p className="text-gray-200 text-base">{story.testimonial}</p>
      </div>
      <div className="flex items-center gap-2 mt-auto">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 ${i < story.rating ? 'fill-[#70CBA2]' : 'fill-gray-600'}`}
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    </div>
  );
};

const SuccessStoryCarousel = ({ stories }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = stories.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(interval);
  }, [total]);

  const goTo = (idx) => setCurrentIndex(idx);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + total) % total);
  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % total);

  return (
    <div className="relative w-full flex flex-col items-center bg-[#0F1338]">
      <div className="flex justify-center items-center gap-2 sm:gap-4 md:gap-6 py-6 sm:py-8 w-full">
        <button
          onClick={prevSlide}
          className="hover:text-[#70CBA2] text-gray-200 rounded-full w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center shadow-lg z-30"
          aria-label="Previous"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div className="flex justify-center items-center w-full max-w-5xl">
          <SuccessStoryCard story={stories[currentIndex]} />
        </div>
        <button
          onClick={nextSlide}
          className="hover:text-[#70CBA2] text-gray-200 rounded-full w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center shadow-lg z-30"
          aria-label="Next"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
      <div className="flex justify-center gap-2 mt-2">
        {stories.map((_, idx) => (
          <button
            key={idx}
            onClick={() => goTo(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              idx === currentIndex ? 'bg-[#70CBA2] w-4' : 'bg-gray-600 hover:bg-gray-500'
            }`}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default SuccessStoryCarousel; 